
import Vue from "vue";
import UIFeatureMixin from "@/mixins/UIFeatureMixin.vue";

export default Vue.extend({
  name: "how-to-apply-content",
  components: {},
  mixins: [UIFeatureMixin],
});
